import { H3 } from '@berlitz/globals'
import RoleBasedView from '@components/RoleBasedView'
import Link from 'next/link'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import * as Scroll from 'react-scroll'
import IconMapping, { mappedIcons } from '../IconMapping'
import { ContactDashboardProps } from './interface'
import { CategoryCard, CategoryCardWrapper, CategoryDetails, CategoryGrid, CategtoryCardContent } from './style'

const ScrollLink = Scroll.Link

const ContactDashboard: React.FC<ContactDashboardProps> = ({ items, active }) => (
  <CategoryGrid>
    {items.map(({ id, slug, title, action, icon, description }) => {
      icon = icon.toLowerCase()
      const CategoryComponent = (
        <div key={id} data-e2e={id}>
          <ScrollLink to="case-subtype" spy={true} smooth={true} duration={500}>
            <Link href={`/support/contact-us/?caseType=${slug}`} legacyBehavior>
              <CategoryCardWrapper>
                <CategoryCard active={slug === active} color={mappedIcons[icon] ? mappedIcons[icon][2] : 'purple'}>
                  <CategtoryCardContent>
                    <IconMapping icon={icon} />
                    <CategoryDetails>
                      <H3>
                        <FormattedMessage id={title} />
                      </H3>
                      <p>
                        <FormattedMessage id={description} />
                      </p>
                    </CategoryDetails>
                  </CategtoryCardContent>
                </CategoryCard>
              </CategoryCardWrapper>
            </Link>
          </ScrollLink>
        </div>
      )
      return action ? (
        <RoleBasedView key={id} configId={action}>
          {CategoryComponent}
        </RoleBasedView>
      ) : (
        CategoryComponent
      )
    })}
  </CategoryGrid>
)

export default ContactDashboard
